<template>
  <v-expansion-panel-content
    ref="branchSelectionStep"
    :disabled="disabled"
    :aria-disabled="disabled"
    class="process-step-header"
  >
    <div slot="header">
      <div class="flex">
        <div class="process-number">{{processNumber}}</div>
        <div class="process-step-name">{{messages.selectDistrictStep}}</div>
      </div>
      <div v-if="displaySelectedDistrictInfo" class="chosen-options">
        <small>
          <div>{{address}}</div>
        </small>
      </div>
    </div>
    <v-card>
      <v-card-text class="info-text" tabindex="0">{{messages.selectDistrictContentText}}</v-card-text>
      <v-progress-linear role="progressbar" v-if="!branchData" class="progress-bar" indeterminate></v-progress-linear>
      <div v-else>
        <v-expansion-panel class="services-wrapper" v-if="checkShowBranchGroups">
          <v-expansion-panel-content
            class="service-expansion-panel region-expansion-panel"
            v-for="(region, index) in branchData"
            :key="index"
          >
            <div slot="header" class="flex" v-if="region">{{region.fullName}}</div>
            <branch-card
              v-if="region.branches.length > 0"
              :branches="region.branches"
              :padding="54"
              :locale="selectedLanguage.lang"
              :region-index="index"
              :only-region-radio-active="onlyKeepThisRegionRadioActive"
              @branch-selected="branchSelected"
            ></branch-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <branch-card
          v-else
          :branches="branchData"
          :locale="selectedLanguage.lang"
          :pre-select-branch="preSelectBranch"
          :region-index="-1"
          :only-region-radio-active="onlyKeepThisRegionRadioActive"
          @branch-selected="branchSelected"
        ></branch-card>
      </div>
    </v-card>
  </v-expansion-panel-content>
</template>

<script>
import RestService from '../services/restService'
import FormatService from '../services/formatService'
import BranchCard from './BranchCard'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'BranchSelection',
  props: [
    'isFirst',
    'disabled',
    'reloaded',
    'processNumber'
  ],
  mixins: [RestService, FormatService],
  components: { BranchCard },
  data: () => ({
    stepExpanded: false,
    displaySelectedDistrictInfo: false,
    customSlotLength: 0,
    branchData: null,
    noPeopleError: false,
    preSelectBranch: null,
    onlyKeepThisRegionRadioActive: null,
    address: '',
    filteredServices: [],
    serviceBranchMap: {}
  }),
  computed: {
    ...mapState([
      'funcDebug',
      'selectedBranch',
      'configuration',
      'isServicesStepValid',
      'selectedServices',
      'branchTranslations',
      'preSelectedBranch',
      'messages',
      'selectedLanguage',
      'preSelectedServiceGroups'
    ]),
    ...mapGetters([
      'isBranchPreselected',
      'isServiceGroupsPreselected'

    ]),
    checkShowBranchGroups: function () {
      return this.configuration.showBranchGroups && !this.isBranchPreselected
    }
  },
  watch: {
    selectedServices (newValue, oldValue) {
      if (this.funcDebug) console.log('BranchSelection:watch:selectedServices')
      // load branch data when service step is valid and branch is second
      if (!this.isFirst && this.isServicesStepValid) {
        if (!this.isBranchPreselected) {
          this.resetSelectedBranch()
          this.displaySelectedDistrictInfo = false
          this.getBranchData()
        } else {
          this.getBranchData()
        }
        // check validation
        this.checkBranchValidity()
        this.$emit('check-steps')
      }
      if ((this.$route.name === 'booking' || this.$route.name === 'servicegroupsbooking') && !this.isFirst) {
        // this is the last unique action when services are preselected
        this.$emit('is-loaded')
      }
    },
    selectedLanguage () {
      this.address = this.getBranchAddressBranchSelection(this.selectedBranch)
    }
  },
  methods: {
    ...mapActions([
      'checkBranchValidity',
      'setSelectedBranch',
      'resetSelectedBranch'
    ]),
    ...mapMutations([
      'setBranchTranslations'
    ]),
    branchSelected (branch, exculsiveRegionIndex) {
      if (this.funcDebug) console.log('BranchSelection:methods:branchSelected')
      this.setSelectedBranch(branch)
      this.displaySelectedDistrictInfo = true
      this.onlyKeepThisRegionRadioActive = exculsiveRegionIndex
      // check validation
      this.checkBranchValidity()
      this.address = this.getBranchAddressBranchSelection(branch)
      this.$emit('data-selected', 'branch')
    },
    getBranchNames (data) {
      if (this.funcDebug) console.log('BranchSelection:methods:getBranchNames')
      for (let k = 0; k < data.length; k++) {
        const branch = data[k]
        if (branch.custom) {
          branch.custom = JSON.parse(branch.custom)
        } else {
          branch.custom = {}
          branch.custom.names = {}
        }
      }
      return data
    },
    loadBranchTranslations () {
      if (this.funcDebug) console.log('BranchSelection:methods:loadBranchTranslations')
      var _this = this
      var tempbranchTranslations = {}
      if (_this.checkShowBranchGroups) {
        for (let l = 0; l < _this.branchData.length; l++) {
          const region = _this.branchData[l]
          for (let k = 0; k < region.branches.length; k++) {
            const branch = region.branches[k]
            tempbranchTranslations[branch.id] = {}
            tempbranchTranslations[branch.id].names = branch.custom.names
          }
        }
      } else {
        for (let k = 0; k < _this.branchData.length; k++) {
          const branch = _this.branchData[k]
          tempbranchTranslations[branch.id] = {}
          tempbranchTranslations[branch.id].names = branch.custom.names
        }
      }
      _this.setBranchTranslations(tempbranchTranslations)
      if (this.$route.name === 'servicebooking' ||
        ((this.$route.name === 'booking' || this.$route.name === 'servicegroupsbooking') && this.isFirst)) {
        // this is the last unique action when services are preselected
        this.$emit('is-loaded')
      }
    },
    filterBranchesInBranchGroups (array) {
      if (this.funcDebug) console.log('BranchSelection:methods:filterBranches')
      var filteredBranchGroups = []
      if (array.length === 0) {
        return Promise.resolve(filteredBranchGroups)
      }
      return Promise.all(array.map((branchGroup) => {
        let filteredBranches = []
        let branches = branchGroup.branches

        if (this.isBranchPreselected) {
          // currently never go there (keep the code in case of behavior change for preselection)
          filteredBranches = branches.filter(branch => this.preSelectedBranch.includes(branch.id))
          branchGroup.branches = this.getBranchNames(filteredBranches)
          // this.filteredBranchGroups.push()
          return Promise.resolve(branchGroup)
        } else if (this.isServiceGroupsPreselected) {
          // Now we filter out the branches that do not have any service that is in any of the
          // preselected service groups
          return this.filterBranchesByPreselectedServiceGroup(branches)
            .then((response) => {
              if (response.length > 0) {
                // only add the branch group to the filtered list if it actually has any branches
                // that serve these preselected services
                branchGroup.branches = this.getBranchNames(response)
                return Promise.resolve(branchGroup)
              }
              return Promise.resolve()
            })
        } else {
          branchGroup.branches = this.getBranchNames(branchGroup.branches)
          return Promise.resolve(branchGroup)
        }
      })).then((arrayBranchGroups) => {
        let arrayResult = arrayBranchGroups.filter((brgr) => !(typeof brgr === 'undefined'))
        return Promise.resolve(arrayResult)
      })
    },
    getBranchData () {
      if (this.funcDebug) console.log('BranchSelection:methods:getBranchData')
      var _this = this
      this.filteredServices = []
      if (_this.isServiceGroupsPreselected) {
        // Retrieve all service groups and create a list of all services that are in any of the preselected groups
        _this.getServiceGroups().then((response) => {
          let serviceGroups = response.data
          for (let i = 0; i < serviceGroups.length; i++) {
            for (let j = 0; j < +_this.preSelectedServiceGroups.length; j++) {
              if (serviceGroups[i].id === _this.preSelectedServiceGroups[j]) {
                for (let k = 0; k < serviceGroups[i].services.length; k++) {
                  this.filteredServices.push(serviceGroups[i].services[k])
                }
              }
            }
          }

          // if Region option is active and not branch is preselected
          if (this.checkShowBranchGroups) {
            this.loadBranchGroups(this.selectedServices)
          } else {
            this.loadBranches(this.selectedServices)
          }
        })
      } else {
        // if Region option is active and not branch is preselected
        if (this.checkShowBranchGroups) {
          this.loadBranchGroups(this.selectedServices)
        } else {
          this.loadBranches(this.selectedServices)
        }
      }
    },
    loadBranchGroups (services) {
      var _this = this
      this.getBranchGroups(services).then(response => {
        if (this.funcDebug) console.log('BranchSelection:methods:loadBranchGroups.getBranchGroups.then')
        let branchData = response.data.filter(region => region.branches.length > 0)
        this.filterBranchesInBranchGroups(branchData).then((response) => {
          _this.branchData = response
          _this.loadBranchTranslations()
        })
      })
    },
    loadBranches (services) {
      var _this = this
      this.getBranchesByServices(services).then(response => {
        if (this.funcDebug) console.log('BranchSelection:methods:getBranchData:getBranches.then')
        let branchData = []
        if (_this.isBranchPreselected) {
          // filter to show only preselected branch
          branchData = response.data.filter(branch => _this.preSelectedBranch === branch.id)
          _this.branchData = _this.getBranchNames(branchData)
          _this.loadBranchTranslations()
          if (_this.branchData.length > 0) {
            _this.preSelectBranch = _this.branchData[0] // for branchCard component
            // _this.branchSelected(_this.branchData[0]) // branchCard component will emit the event that wwill call that
          }
        } else {
          branchData = response.data
          _this.branchData = _this.getBranchNames(branchData)
          _this.loadBranchTranslations()
        }
      })
    },
    setfocus () {
      var _this = this
      this.$nextTick(() => {
        _this.$refs.branchSelectionStep.$el.focus()
      })
    },
    filterBranchesByPreselectedServiceGroup (branches) {
      var _this = this
      return Promise.all(branches.map((branch) => {
        // for each branch retrieve the services is serves and add teh result to the branch
        return this.getServicesByBranch(branch.id).then((response) => {
          branch.services = response.data
          return branch
        }).catch(() => {
          branch.services = []
          return branch
        })
      })).then((branchesWithServices) => {
        // Once all services have been retrieved
        // console.log('branchesWithServices' + branchesWithServices)
        let newBranches = []
        for (let i = 0; i < branchesWithServices.length; i++) {
          let found = false
          let services = branchesWithServices[i].services
          for (let j = 0; j < services.length; j++) {
            for (let k = 0; k < _this.filteredServices.length; k++) {
              if (_this.filteredServices[k].publicId === services[j].publicId) {
                // This branch has at least one service that is in the list of the preselected service groups, so ok to add the branch to the filtered list
                found = true
                continue
              }
            }
          }
          if (found) { newBranches.push(branches[i]) }
        }
        return newBranches
      })
    }
  },
  mounted () {
    if (this.funcDebug) console.log('BranchSelection:mounted')
    eventHub.$on('branch-step-focus', this.setfocus)
    if (this.isFirst) {
      this.getBranchData()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
